import { Button, Card, CircularProgress, IconButton, InputBase, List, Paper, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { Box } from '@mui/system'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getCentersList } from '../../services/form/center'
import { Context } from '../../contexts/Context'
import ListComponent from './ListComponent'

export default function CentersList ({ token, currentLocation }) {
  const { handleToken } = useContext(Context)
  const [centersList, setCentersList] = useState()
  const [pageButtonStatus, setPageButtonStatus] = useState({ pre: true, next: true })
  const [searchParams, setSearchParams] = useSearchParams()
  const name = searchParams.get('name') || ''
  let page = +searchParams.get('page') || 1
  if (page < 1) page = 1
  const [input, setInput] = useState(name)
  const navigate = useNavigate()

  const handleInput = (e) => {
    setInput(e.target.value)
  }
  const handleSearch = (e) => {
    e.preventDefault()
    setSearchParams({ name: input, page: 1 })
    getCenters(input, 1, currentLocation)
  }
  const handlePagination = (pageNum) => {
    getCenters(name, pageNum)
    setSearchParams({ name, page: pageNum })
  }

  async function getCenters (name, page, currentLocation) {
    if (!name && !currentLocation) {
      setCentersList(null)
      return
    }
    setCentersList({ results: null, totalPages: 0 })
    getCentersList(name?.trim(), page, token, currentLocation)
      .then(res => {
        if (res?.status === 'Unauthorized') {
          handleToken(null)
          navigate('/login')
        } else {
          if (res) {
            setCentersList(res)
            if (res.totalPages > res.page) {
              setPageButtonStatus({ ...pageButtonStatus, next: false })
            } else if (res.totalPages <= res.page) {
              setPageButtonStatus({ ...pageButtonStatus, next: true })
            }
          }
          if (page > 1) {
            setPageButtonStatus({ ...pageButtonStatus, pre: false })
          } else if (page < 2) setPageButtonStatus({ ...pageButtonStatus, pre: true })
        }
      })
  }

  useEffect(() => {
    getCenters(name?.trim(), page, currentLocation)
    // eslint-disable-next-line
  }, [currentLocation])

  return (
    <Box sx={{ margin: 'auto', width: '100%', bgcolor: 'background.paper', maxWidth: '700px' }}>
      <Paper
        component='form'
        sx={{ margin: '0px', p: '2px 4px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 'auto' }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder='Search center name'
          inputProps={{ 'aria-label': 'search' }}
          onChange={handleInput}
          value={input}
        />
        <IconButton onClick={handleSearch} type='submit' sx={{ p: '10px' }} aria-label='search'>
          <SearchIcon />
        </IconButton>
      </Paper>

      {!centersList
        ? <ListMessage message='Please Search center name/address or allow location access.' />
        : (!centersList?.results && (name || currentLocation))
            ? <Box sx={{ display: 'flex' }}> <CircularProgress sx={{ margin: '20vh auto ' }} /> </Box>
            : centersList.results.length === 0
              ? <ListMessage message=' Centers not found ! ' />
              : <List> {centersList.results.map(center => <ListComponent key={center.centerId} center={center} />)} </List>}

      {centersList?.results?.length
        ? <Box sx={{ padding: '0px', margin: '5px 5px 50px', maxWidth: '800px', display: 'flex', justifyContent: 'space-between' }}>
          <Button disabled={pageButtonStatus.pre} onClick={() => handlePagination(+page - 1)} variant='outlined'>Previous</Button>
          <Button disabled={centersList?.totalPages <= page} onClick={() => handlePagination(+page + 1)} variant='outlined'>Next</Button>
        </Box>
        : null}
    </Box>
  )
}

function ListMessage ({ message }) {
  return (
    <Card sx={{ padding: '20px', margin: ' 10px auto', maxWidth: '800px' }}>
      <Typography size='sm' gutterBottom variant='h5' component='div'>
        {message}
      </Typography>
    </Card>
  )
}
